module.exports = __webpack_public_path__ + "static/media/thumb-papel.b712b26b.png";